import React, {useContext} from 'react'
import '../styles/header.css';
import { Link } from 'react-router-dom'
import logo from '../Logo.png'
import {PlanContext} from '../Store'

const Menu = () => {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);
    const [plan] = useContext(PlanContext)
    return (
        <div>
            
            <div className="header">
                <div className="headerLogo">
                    <Link to="/">
                        <img src={logo} alt="" className="logo"></img>
                    </Link>
                </div>
                <div className="headerNav">
                    <div className={isMenuOpen ? "open" : "nav"}>
                        <button className="closeButton" onClick={ () => setIsMenuOpen(false)}>Close</button>
                        <Link to="/explore" className="navBtn" onClick={ () => setIsMenuOpen(false)}>Study Sets</Link>
                        {plan === 'parent' && (
                        <Link to="/find" className="navBtn" onClick={ () => setIsMenuOpen(false)}>Tutoring</Link>)}
                        <Link to="/videochat" className="navBtn" onClick={ () => setIsMenuOpen(false)}>Video Chat</Link>
                        <Link to="/profile" className="navBtn navBtnOutline" onClick={ () => setIsMenuOpen(false)}>Account</Link>
                    </div>
                    <button className="hamButton" onClick={setIsMenuOpen}>Menu</button>
                </div>
            </div>
            
            <div className="headerBodySpacer"></div>

        </div>
    )
}

export default Menu